/* Musas - reveal on scroll (fiel ao site atual: Elementor fadeIn + fadeInLeft + stagger nos cards).
   Carregado 1x pelo theme.liquid. Roda no load e tambem no shopify:section:load (editor). */
(function () {
  if (!('IntersectionObserver' in window)) return; /* fallback: tudo visivel */

  /* injeta o CSS uma vez */
  if (!document.getElementById('musas-anim-css')) {
    var css = document.createElement('style');
    css.id = 'musas-anim-css';
    css.textContent =
      '.m-reveal{opacity:0;transform:translateY(22px);' +
      'transition:opacity .7s cubic-bezier(.22,.61,.36,1),transform .7s cubic-bezier(.22,.61,.36,1);' +
      'will-change:opacity,transform;}' +
      '.m-reveal.m-rev-left{transform:translateX(-44px);}' +
      '.m-reveal.m-rev-right{transform:translateX(44px);}' +
      '.m-reveal.is-in{opacity:1!important;transform:none!important;}' +
      '@media (prefers-reduced-motion: reduce){.m-reveal{opacity:1!important;transform:none!important;transition:none!important;}}';
    document.head.appendChild(css);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function tag(root, sel, cls, stagger) {
    root.querySelectorAll(sel).forEach(function (el, i) {
      if (el.classList.contains('m-reveal')) return;
      el.classList.add('m-reveal');
      if (cls) el.classList.add(cls);
      if (stagger) el.style.transitionDelay = ((i % 3) * 0.18 + 0.05) + 's';
      io.observe(el);
    });
  }

  function apply(root) {
    root = root || document;
    /* titulos / textos / CTAs das secoes */
    tag(root, '.musas-eyebrow');
    tag(root, '.musas-h2');
    tag(root, '.musas-ingredients__sub, .musas-faq__sub, .musas-ba__sub, .musas-community__sub, .musas-story__quote');
    tag(root, '.musas-ingredients__cta, .musas-faq__cta');
    /* story / comunidade: imagem desliza da esquerda, texto da direita */
    tag(root, '.musas-story__media', 'm-rev-left');
    tag(root, '.musas-story__copy', 'm-rev-right');
    tag(root, '.musas-community__media', 'm-rev-left');
    tag(root, '.musas-community__copy', 'm-rev-right');
    /* antes/depois */
    tag(root, '.musas-ba__card');
    /* grids com stagger (cards) */
    tag(root, '.musas-nutrient', null, true);
    tag(root, '.musas-plan', null, true);
    tag(root, '.musas-faq__item', null, true);
  }

  function start() { apply(document); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  /* editor do tema: re-aplica quando uma secao recarrega */
  document.addEventListener('shopify:section:load', function (e) {
    apply(e.target || document);
  });
})();
